import { z } from 'zod/v4';

import { applicationRoleSchema } from './application-role.schema';

export const accountApplicationGroupSchema = z.object({
  product: z.object({
    id: z.number().min(1),
    name: z.string().min(1),
    displayName: z.string().min(1),
  }),
  groups: z.array(
    z.object({
      name: z.string().min(1),
      roles: z.array(applicationRoleSchema),
    })
  ),
});

export type AccountApplicationGroup = z.infer<
  typeof accountApplicationGroupSchema
>;
